import { VisitType } from './constants';

export const checkIsModernHealthVisitType = (visitType) => visitType === VisitType.ModernHealth;
